import React from 'react';
import { Box, Divider, Typography } from '@mui/material';

interface ChatTimelineNoteProps {
  children: React.ReactNode;
}

/** Teams/Google Chat-style inline timeline note (not a message bubble). */
export default function ChatTimelineNote({ children }: ChatTimelineNoteProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        my: 1.25,
        px: 1,
      }}
    >
      <Divider sx={{ flex: 1 }} />
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          fontStyle: 'italic',
          textAlign: 'center',
          lineHeight: 1.45,
          flexShrink: 0,
          maxWidth: '72%',
        }}
      >
        {children}
      </Typography>
      <Divider sx={{ flex: 1 }} />
    </Box>
  );
}
